import React from 'react'
import GasFeeSlider from './GasFeeSlider';

const GasFee = () => {
    return (
        <div>
            <div>
                {/* Hero section start */}
                <section className="_blog_nft_hero_wrapper">
                    <div className="container">
                        <div className="_blog_nft_hero_wrap">
                            <div className="row align-items-center">
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <img src="assets/img/bloghero.png" alt="chobi" className="_blog_nft_hero_img" />
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <div className="_blog_nft_hero_right">
                                        <h2 className="_blog_nft_hero_right_title">Introducing a gas-free
                                            NFT marketplace, on Polygon.</h2>
                                        <p className="_blog_nft_hero_right_txt">While we're proud to be the first and largest NFT
                                            marketplace, we're even prouder to be the first to provide cross-blockchain support,
                                            starting with a gas-free marketplace on the Polygon blockchain.
                                        </p>
                                        <a href="#0" className="_blog_nft_hero_right_link">Start Creating</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Hero section ends */}
                {/*video1 nft wrapper*/}
                <section className="_video1_nft_wrapper">
                    <div className="_video1_nft_wrap">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12">
                                    <div className="_video1_nft_head">
                                        <h3 className="_video1_nft_head_txt">Goodbye gas fees. Hello gas-free</h3>
                                        <p className="_video1_nft_head_para">From creating,
                                            selling, and selling — it’s all gas-free, on Polygon.
                                        </p>
                                    </div>
                                    <div className="_video1_nft_thumb_wrap">
                                        <div className="_video1_nft_thumb">
                                            <div className="_video1_nft_thumb_img">
                                                <img src="assets/img/video1-img.png" alt="chobi" className="_video1_nft_thumb_img_tag" />
                                            </div>
                                            <button className="_video1_nft_thumb_btn">
                                                <span className="_video1_nft_thumb_btn_sp">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={26} fill="none" viewBox="0 0 24 26">
                                                        <path fill="#fff" d="M21.754 10.14c2.265 1.234 2.265 4.486 0 5.72L4.818 25.096C2.647 26.279 0 24.707 0 22.236V3.764C0 1.292 2.647-.28 4.818.905l16.936 9.235Z" />
                                                    </svg>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*video1 nft wrapper end*/}
                {/*cross slider nft wrapper*/}
                <GasFeeSlider/>
                {/*cross slider nft wrapper end*/}
            </div>

        </div>
    )
}

export default GasFee;